import { useEffect, useState } from 'react';
import api from '../api';

// Estado compartilhado das notificações do app (sino do cabeçalho, tela /notificacoes e aviso na tela).
let estado = { lista: [], naoLidas: 0, carregado: false };
let desde = null; // horário do servidor na última consulta (para buscar só as novas)
let token = null;
const ouvintes = new Set();
const ouvintesNovas = new Set();

const publicar = (novo) => {
  estado = { ...estado, ...novo };
  ouvintes.forEach((fn) => fn(estado));
};

// Token explícito: logo após o login ele ainda não foi gravado no localStorage que o `api` lê
const config = (params) => ({ ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}), ...(params ? { params } : {}) });

export function configurarNotificacoes(novoToken) {
  token = novoToken;
}

export async function carregarNotificacoes() {
  try {
    const { data } = await api.get('notificacoes', config());
    desde = data.agora;
    publicar({ lista: data.notificacoes, naoLidas: data.naoLidas, carregado: true });
  } catch (e) {
    // sem conexão: tenta de novo na próxima verificação
  }
}

/** Busca só as notificações novas; avisa quem escuta (aviso na tela) quando chegar alguma. */
export async function verificarNovas() {
  if (!desde) return carregarNotificacoes();
  try {
    const { data } = await api.get('notificacoes', config({ desde }));
    desde = data.agora;
    const conhecidas = new Set(estado.lista.map((n) => n._id));
    const novas = data.notificacoes.filter((n) => !conhecidas.has(n._id));
    publicar({ lista: [...novas, ...estado.lista].slice(0, 50), naoLidas: data.naoLidas });
    if (novas.length) ouvintesNovas.forEach((fn) => fn(novas));
  } catch (e) {
    // ignore
  }
  return undefined;
}

export async function marcarNotificacoesLidas() {
  if (estado.naoLidas === 0) return;
  publicar({ naoLidas: 0 });
  try {
    await api.post('notificacoes/lidas', {}, config());
  } catch (e) {
    // ignore
  }
}

export function reiniciarNotificacoes() {
  desde = null;
  token = null;
  publicar({ lista: [], naoLidas: 0, carregado: false });
}

export const aoChegarNovas = (fn) => {
  ouvintesNovas.add(fn);
  return () => ouvintesNovas.delete(fn);
};

export function useNotificacoes() {
  const [atual, setAtual] = useState(estado);
  useEffect(() => {
    ouvintes.add(setAtual);
    setAtual(estado);
    return () => ouvintes.delete(setAtual);
  }, []);
  return atual;
}

// Link da notificação dentro do app: mesmo site vira caminho interno; outro site abre a lista.
export function caminhoInterno(link) {
  if (!link) return null;
  try {
    const url = new URL(link, window.location.origin);
    const mesmoApp = url.origin === window.location.origin || /rivierafc/.test(url.hostname);
    return mesmoApp ? `${url.pathname}${url.search}` : null;
  } catch (e) {
    return null;
  }
}
